<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
import ResetPasswordView from '../../../auth/components/ResetPasswordView.vue'

definePage({
    meta: {
        isGuest: true,
    }
})
</script>

<template>
  <ResetPasswordView />
</template>